/**
 * DEPRECATED. Use `entitySelector.js` instead.
 *
 * Using this file is deprecated. All logic should be moved to `entitySelector.js`.
 */

import { createSelector } from 'reselect';
import { getSubjects } from '../../selectors/entitySelectors';

export const getObjects = state => state.booking.objects;
export const resourceAdditionSelector = state => state.booking.resourceadditions;
export const getOffersSelector = state => state.booking.offers;
export const getResults = state => state.booking.offers.results;
const criteriaSelector = state => state.reservation.criteria;

export const subjectFormFieldSelector = createSelector(
  getSubjects,
  criteriaSelector,
  (subjects, criteria) => Object.keys(subjects).reduce((acc, subject) => {
    const match = criteria.subjects.find(cs => cs.subject_id === subject);
    acc[`subject-${subject}`] = (match && match.quantity) || 0;
    return acc;
  }, {})
);
